import { createAsyncThunk } from "@reduxjs/toolkit";

import { postData, postFormData } from "../../../services";
import { fetchDataAxios } from "../../../apiConfig";

// export const getCaseThunk = createAsyncThunk(
//   "/getCase",
//   async (payload, { rejectWithValue }) => {
//     try {
//       const result = await postFormData(`/cases/getCase`, payload);
//       return result.data.response;
//     } catch (err) {
//       return rejectWithValue({ error: err?.response?.data });
//     }
//   }
// );

export const getCaseThunk = createAsyncThunk(
  "/getCase",
  async (productRequest, { rejectWithValue }) => {
    try {
      const result = await postData(`/cases/getCase`, {
        ...productRequest,
      });
      return result.data.response;
    } catch (err) {
      return rejectWithValue({ error: err?.response?.data });
    }
  }
);

export const getActivityDetailsThunk = createAsyncThunk(
  "/getActivityDetails",
  async (productRequest, { rejectWithValue }) => {
    try {
      const result = await postData(`/cases/getActivityDetails`, {
        ...productRequest,
      });
      return result.data.response;
    } catch (err) {
      return rejectWithValue({ error: err?.response?.data });
    }
  }
);

export const saveOrUpdateActivityDetailsThunk = createAsyncThunk(
  "/saveOrUpdateActivityDetails",
  async (payload, { rejectWithValue }) => {
    try {
      const result = await postFormData(
        `/cases/saveOrUpdateActivityDetails`,
        payload
      );
      return result.data.response;
    } catch (err) {
      return rejectWithValue({ error: err?.response?.data });
    }
  }
);
